import { FETCH_OFFICES, UPDATE_OFFICE_DETAILS } from "../constants/offices";

export function fetchOffices() {
  return {
    type: FETCH_OFFICES,
    api: true,
    payload: {
      method: "GET",
      url: "/offices",
    },
  };
}

export function editOfficeDetails(officeId: number, body: {}) {
  return {
    type: UPDATE_OFFICE_DETAILS,
    api: true,
    payload: {
      method: "PATCH",
      url: `/office/${officeId}`,
      data: body,
    },
    data: { officeId },
  };
}
